export const showPriceRange = (product) => {
  let result = `$${parseFloat(product?.price).toFixed(2)}`;
  if (product?.isOnePrice) {
    result = `$${parseFloat(product?.price).toFixed(2)}`;
  } else if (product?.minPrice || product?.minPrice === 0) {
    result = `$${parseFloat(product?.minPrice).toFixed(2)} - $${parseFloat(
      product?.maxPrice
    ).toFixed(2)}`;
  }
  return result;
};

export const onWheelPreventChangeNumberField = (e) => {
  e.target.blur();
  e.stopPropagation();
};

export const buildProviderPriceOverrides = (
  connectedProviders,
  CONTEXT_TYPES
) => {
  const providerPriceOverride = [];
  if (!connectedProviders) {
    return providerPriceOverride;
  }
  Object.keys(connectedProviders).forEach((modItem) => {
    if (connectedProviders[modItem]) {
      providerPriceOverride.push({
        context_type: CONTEXT_TYPES.provider,
        context_value: modItem,
        name: modItem,
        price: 0,
        pickupPrice: 0,
        locked: true,
      });
    }
  });
  return providerPriceOverride;
};

export const cloneProviderPriceOverrides = (overrides = []) =>
  (overrides || []).map((item) => ({
    ...item,
    priceOverride: item?.priceOverride
      ? cloneProviderPriceOverrides(item.priceOverride)
      : item?.priceOverride,
  }));

const isSameProvider = (item, contextValue) =>
  item?.context_value === contextValue || item?.name === contextValue;

const normalizeName = (value) => String(value || '').trim().toLowerCase();

/**
 * A size row points at an item size through `context_value`. Rows made on the
 * Modifier Groups page carry none, and rows saved before that page wrote the
 * size id carry the row's own `_id` instead. Both are unbound: they belong to
 * no item yet, so they may be claimed by name.
 */
export const isUnboundSizeOverride = (override) =>
  !override?.context_value || override.context_value === override?._id;

/**
 * Whether a size row holds the price for `size`. A row already bound to a
 * different item's size only looks the same because two items named a size
 * the same way, and must not lend that item its price.
 */
export const sizeOverrideMatchesSize = (override, size) => {
  const sizeId = size?._id || size?.context_value;
  if (!isUnboundSizeOverride(override)) {
    return Boolean(sizeId) && override.context_value === sizeId;
  }
  const overrideName = normalizeName(override?.name);
  return Boolean(overrideName) && overrideName === normalizeName(size?.name);
};

export const mergeProviderPriceOverrides = (
  existing = [],
  connectedProviders,
  CONTEXT_TYPES,
  fallbackPrice = 0
) => {
  const existingList = existing || [];
  const built = buildProviderPriceOverrides(connectedProviders, CONTEXT_TYPES);
  if (!built.length) {
    return existingList;
  }

  // Keep saved provider rows and their prices. Only append providers that are
  // connected but missing from the payload. Rebuilding from connectedProviders
  // was zeroing overview-saved prices on the standalone modifier group page.
  const merged = existingList.map((item) => ({ ...item }));

  built.forEach((provider) => {
    const alreadySaved = merged.some((item) =>
      isSameProvider(item, provider.context_value)
    );
    if (!alreadySaved) {
      merged.push({
        ...provider,
        price: fallbackPrice,
        pickupPrice: fallbackPrice,
      });
    }
  });

  return merged;
};

export const addDefaultPriceOverride = (
  currentCategory,
  menu,
  CONTEXT_TYPES,
  formState
) => {
  let targetConnectedProviders;
  if (currentCategory) {
    targetConnectedProviders = currentCategory.connectedProviders;
  } else {
    targetConnectedProviders = menu.connectedProviders;
  }
  formState.list?.forEach((item) => {
    const hasModItems = item.priceOverride?.some(
      (it) => it.context_type === CONTEXT_TYPES.modifierItem
    );
    if (!hasModItems) {
      item.priceOverride = mergeProviderPriceOverrides(
        item.priceOverride,
        targetConnectedProviders,
        CONTEXT_TYPES,
        item.price
      );
      return;
    }
    item.priceOverride.forEach((it) => {
      if (it.context_type === CONTEXT_TYPES.modifierItem) {
        it.priceOverride = mergeProviderPriceOverrides(
          it.priceOverride,
          targetConnectedProviders,
          CONTEXT_TYPES,
          it.price ?? item.price
        );
      }
    });
  });
  return formState;
};

export const getNextIDsAfterConfirmPopup = (data) => {
  let newProductId = '';
  let newCatId = '';

  if (!data) {
    return null;
  }

  if (data?.search) {
    newProductId = data?.search?.split('pid=')?.[1]?.split('&')?.[0];
    newCatId = data?.search.split('cid=')?.[1]?.split('&')?.[0];
  }

  return {
    newProductId,
    newCatId,
  };
};

export const menuAvailableStyles = (available) => {
  return {
    opacity: available ? 1 : 0.6,
    pointerEvents: available ? 'auto' : 'none',
  };
};
